<template>
  <div>
    <h2 class="font-bold text-18px pb-0.5">Flights</h2>
    <el-scrollbar class="h-[calc(100%_-_40px)] flights-custom-scroll">
      <div class="flex gap-1 min-h-full">
        <FlightCardCol v-for="(col, index) in flightCols" :key="col.status">
          <template slot="header">
            <CampaignStatus :status="col.status" />
            <div v-if="index === 0 && col.flights.length > 0" class="mr-1">
              <el-tooltip
                v-if="($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) && !$is_PM && !$is_GD"
                class="item"
                effect="dark"
                content="New flight"
                placement="top-start"
              >
                <button @click="addFlight"><i class="el-icon-plus"></i></button>
              </el-tooltip>
            </div>
          </template>
          <!-- body -->
          <div><FlightCard :data="col.flights" :isFirst="index === 0" :campaign="campaign" /></div>
          <!-- end -->
        </FlightCardCol>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FlightCardCol from '@/components/social-products/social-boost/parts/FlightCardCol.vue'
import CampaignStatus from '@/components/social-products/social-boost/parts/CampaignStatus.vue'
import FlightCard from '@/components/social-products/social-boost/parts/FlightCard'

export default {
  components: {
    FlightCardCol,
    CampaignStatus,
    FlightCard,
  },
  data() {
    return {
      flightColsLayout: [
        {
          status: 0,
          flights: [],
        },
        {
          status: 2,
          flights: [],
        },
        {
          status: 1,
          flights: [],
        },
        {
          status: 3,
          flights: [],
        },
        {
          status: 4,
          flights: [],
        },
        {
          status: 5,
          flights: [],
        },
        {
          status: 6,
          flights: [],
        },
        {
          status: 7,
          flights: [],
        },
      ],
    }
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['campaign']),
    flightCols() {
      const flights = this.campaign?.flights || []
      const flightCols = this.flightColsLayout.map((col) => {
        const flightsByStatus = flights.filter((flight) => flight.status === col.status)
        return { ...col, flights: flightsByStatus }
      })
      return flightCols
    },
  },
  methods: {
    addFlight() {
      this.$router.push({ name: 'social-boost-add-flight', params: { id: this.$route.params.id } })
    },
  },
}
</script>
<style lang="scss">
.flights-custom-scroll {
  .el-scrollbar__view {
    height: 100%;
  }
  .el-scrollbar__wrap {
    -ms-overflow-style: none;
    scrollbar-width: none;
    margin-right: 0 !important;
  }
  .el-scrollbar__wrap::-webkit-scrollbar {
    display: none;
  }
}
</style>
